<template>
  <FlatDealRow v-if="model.flat_deal && !isStaff" :campaign-id="campaignId" />
  <CampaignRow v-else :campaign-id="campaignId" :pulsating="pulsating" />
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useUserStore } from '@/store/modules/user'

import CampaignRow from './CampaignRow.vue'
import FlatDealRow from './FlatDealRow.vue'

export default defineComponent({
  name: 'CampaignCard',
  components: {
    CampaignRow,
    FlatDealRow
  },
  props: {
    campaign: {
      type: Object,
      required: true
    },
    pulsating: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { isStaff } = useUserStore()
    const campaignId = computed(() => {
      return props.campaign.id
    })
    const model = computed(() => {
      return props.campaign.attributes
    })

    return { campaignId, model, isStaff }
  }
})
</script>
